export default {
  performancePage: {
    url: '/promotion/performancePage',
    method: 'post',
    desc: '秒杀活动-已参加'
  },
  recommendationsPage: {
    url: '/promotion/recommendationsPage',
    method: 'post',
    desc: '秒杀活动-可报名'
  },
  updatePromotionPerformance: {
    url: '/promotion/updatePromotionPerformance',
    method: 'post',
    desc: '秒杀活动-已参加修改'
  },
  getPromotionPerformanceGoodsList: {
    url: '/promotion/getPromotionPerformanceGoodsList',
    method: 'post',
    desc: '秒杀活动已报名商品信息'
  },
}
